import api from '../../../utils/api'
import types from '../mutations/mutation-types'
import { standAloneApps } from '../../../config/constants'

export default {
  getLanguages ({ commit }) {
    api.buildRequest('languages', 'GET').then(({ data }) => {
      commit(types.GENERAL.LOAD_LANGUAGES, data.payload)
    })
  },
  loadGenericApps ({ commit }) {
    const url = 'app?deployed=true'
    api.buildRequest(url, 'GET')
      .then(({ status, data: { payload } }) => {
        if (status === 200) {
          let allApps = payload.apps.map(each => ({
            name: each.name,
            value: `GENERIC_SMS_APP###${each.name}`
          }))
          allApps = allApps.concat(standAloneApps)
          commit(types.GENERAL.LOAD_APPS, allApps)
        }
      })
  },
  async loadAllKeywords ({ commit }) {
    console.log('inside load all keyword')
    const url = 'all-keywords'
    const response = await api.buildRequest(url, 'GET')
    const { status, data: { payload } } = response
    console.log(response.data.payload.map(each => each.keyword))
    console.log(payload.map(each => each.keyword))
    if (status === 200) {
      commit(types.GENERAL.LOAD_KEYWORDS, payload.map(each => each.keyword))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/general.js